import React from 'react'
import PropTypes from 'prop-types'
import { ContextHeadline } from '@aok/text-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'
import formatDate from '../../../utils/formatDate'
import { getHeadlineText } from '../../../utils/TextUtils'

function TemplateHeadline({ subtitle, headline, readingTime, releaseDate, lastUpdated, author, abstract, className }) {
  const showMetaInformation = author?.name || readingTime || releaseDate || lastUpdated

  return (
    <div data-tracking-name="template-headline" className={className}>
      {/* Subtitle */}
      {subtitle && <p className="mb-16 text-18ab42 text-16 leading-24">{subtitle}</p>}

      {/* Headline */}
      <ContextHeadline
        tag={headline.tag}
        text={getHeadlineText(headline, 'text-18ab42')}
        className="text-005e3f text-40 leading-48 font-semibold font-buenos-aires 480:text-48 480:leading-60 1280:text-64 1280:leading-76"
      />

      {/* Meta information */}
      {showMetaInformation && (
        <div className="mt-32 text-6d767c text-16 leading-24 flex items-center flex-wrap gap-x-8">
          {!!author?.name && <p>{`Autor: ${author.name}`}</p>}

          {/* Separation dot */}
          {author?.name && (releaseDate || readingTime || lastUpdated) && (
            <span className="w-4 h-4 flex-shrink-0 bg-6d767c rounded-full relative bottom-2" role="presentation"></span>
          )}

          {!!releaseDate && (
            <p>
              <span className="sr-only">Veröffentlicht am:</span>
              {`${formatDate(releaseDate)}`}
            </p>
          )}

          {/* Separation dot */}
          {releaseDate && (author?.name || readingTime || lastUpdated) && (
            <span className="w-4 h-4 flex-shrink-0 bg-6d767c rounded-full relative bottom-2" role="presentation"></span>
          )}

          {!!readingTime && (
            <>
              <p>{`${readingTime} Lesedauer`}</p>
            </>
          )}

          {/* Separation dot */}
          {lastUpdated && (author?.name || releaseDate || readingTime) && (
            <span className="w-4 h-4 flex-shrink-0 bg-6d767c rounded-full relative bottom-2" role="presentation"></span>
          )}

          {!!lastUpdated && (
            <>
              <p>{`Aktualisiert am: ${formatDate(lastUpdated)}`}</p>
            </>
          )}
        </div>
      )}

      {/* Abstract */}
      {abstract && <p className={`text-20 leading-28 ${showMetaInformation ? 'mt-24' : 'mt-16'}`}>{abstract}</p>}
    </div>
  )
}

TemplateHeadline.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string,
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  readingTime: PropTypes.string,
  releaseDate: PropTypes.string,
  lastUpdated: PropTypes.string,
  author: PropTypes.shape({
    name: PropTypes.string,
  }),
  abstract: PropTypes.string,
}

TemplateHeadline.defaultProps = {
  className: '',
  headline: {
    text: defaultProps.HEADLINE,
  },
}

export default TemplateHeadline
